<template>
    <div class="text max-w-2xl">
        <div class="phone:text-2xl text-3xl font-bold text-white tracking-widest uppercase tablet:-mt-3">
            <slot name="title-text"></slot>
        </div>
        <div class="phone:text-2xl text-3xl font-light text-white tracking-widest uppercase">
            <slot name="subtitle-text"></slot>
        </div>
        <div class="text-lg text-white mt-6">
            <slot name="content-text"></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ContentText',
};
</script>

<style scoped>

</style>
